<!-- eslint-disable vue/no-v-html -->
<template>
  <ul class="pl-9">
    <li
      v-for="(item, index) in sectionData"
      :key="hash(item)"
      class="my-2 rounded border border-solid border-gray-400 bg-white"
    >
      <div class="flex items-center px-2.5 py-2.5 tablet:px-5">
        <div class="w-full grow basis-0 text-lg font-bold text-blue-400">
          {{ item.name }}
        </div>
        <button
          class="flex h-7 w-7 basis-7 items-center justify-center"
          @click="handleClick(index)"
        >
          <IconDecrease
            v-if="current === index"
            class="h-6 w-6 text-blue-400"
          />
          <IconAdd v-else class="h-6 w-6 text-blue-400" />
        </button>
      </div>
      <div
        v-if="current === index"
        class="border-t border-solid border-gray-400 px-2.5 py-2.5 tablet:px-5 tablet:py-4"
      >
        <p
          class="description text-sm leading-6 text-gray-600"
          v-html="provideSanitized(item.description || '')"
        />
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ISection } from '@/assets/types/api/Pages';

  interface IProps {
    sectionData: ISection[];
  }

  withDefaults(defineProps<IProps>(), {
    sectionData: () => [],
  });

  const current = ref<number>(-1);

  const handleClick = (index: number): void => {
    const result: number = current.value === index ? -1 : index;
    current.value = result;
  };
</script>

<style lang="scss" scoped>
  .description:deep(a) {
    @apply text-blue-400 hover:underline;
  }

  .description:deep(ul) {
    @apply list-disc pl-7;
  }

  .description:deep(ol) {
    @apply list-decimal pl-6;
  }
</style>
